const CONSENT_KEY = "gofounder_cookie_consent";
const GA_MEASUREMENT_ID = process.env.GATSBY_GA_MEASUREMENT_ID;

let analyticsInitialized = false;

const readConsent = () => {
  if (typeof window === "undefined") {
    return null;
  }

  const raw = window.localStorage.getItem(CONSENT_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const hasAnalyticsConsent = () => {
  const consent = readConsent();
  return Boolean(consent && consent.analytics === true);
};

const ensureGtag = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }

  if (!GA_MEASUREMENT_ID) {
    return false;
  }

  if (!document.getElementById("ga4-script")) {
    const script = document.createElement("script");
    script.id = "ga4-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    anonymize_ip: true,
    send_page_view: false,
  });

  return true;
};

export const initAnalyticsIfConsented = () => {
  if (analyticsInitialized) {
    return true;
  }

  if (!hasAnalyticsConsent()) {
    return false;
  }

  const ready = ensureGtag();
  analyticsInitialized = ready;
  return ready;
};

export const trackPageView = path => {
  if (typeof window === "undefined") {
    return;
  }

  if (!analyticsInitialized) {
    const initialized = initAnalyticsIfConsented();
    if (!initialized) {
      return;
    }
  }

  if (!window.gtag || !GA_MEASUREMENT_ID) {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: path || window.location.pathname,
    page_location: window.location.href,
    page_title: document.title,
    send_to: GA_MEASUREMENT_ID,
  });
};

export const saveConsent = consent => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(CONSENT_KEY, JSON.stringify(consent));
};

export const loadFontsDeferred = () => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (document.getElementById("gf-fonts-link")) {
    return;
  }

  const link = document.createElement("link");
  link.id = "gf-fonts-link";
  link.rel = "stylesheet";
  link.href = "https://fonts.googleapis.com/css2?family=Montserrat+Alternates:wght@600;700&family=Mulish:ital,wght@0,400;0,600;0,700;1,400&display=swap";
  document.head.appendChild(link);
};

export const CONSENT_STORAGE_KEY = CONSENT_KEY;